<template>
  <v-col md="4">
    <v-card class="neu-glow">
      <v-row class="mx-0 pa-4" justify="space-between" align="center">
        <!-- title and subtitle -->
        <div>
          <div class="text-h6 float-left mr-1" v-text="$t('Dashboard.headingOperational')"></div>
          <div class="text-h6 float-left">: {{this.user.d_charts.ProfitsTot[0]}}</div>
        </div>
        <!-- Stats -->
        <div class="d-flex flex-column align-end">
          <v-bottom-navigation
            v-model="showingTasks"
            color="secondary"
            class="neu-glow with-radius"
            height="40"
          >
            <v-btn value="View All" to='./reports/profit_loss'>
              <span v-text="$t('Dashboard.viewAll')"></span>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </v-row>
      <v-card-text class="py-0">
        <line-chart v-if="data"
            :data="buildChart"
            :options="option"
            :style="{ height: '300px' }"
            class="pt-5"
            id='Chart'
        />
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import colors from "vuetify/lib/util/colors";
import LineChart from "@/components/ChartJS/LineChart";
export default {
  components: { LineChart },
  computed : {
    ...mapGetters(["user"],["chartoptions"]),
    formattedTimeframe: function ()
    {
      let rsp='', options = {  day: '2-digit', month: 'short' };
      let prcs=this.user.timeframe;
      prcs.forEach(element => rsp+=(new Date(element).toLocaleDateString(this.user.locale || 'en', options).split('T')[0]+ ' - '));
      return rsp.slice(0, -3);
    },
    buildChart(){
      this.data.labels = this.user.d_charts.labels_chart;
      this.data.datasets=[];
      let datasetscount=0
      let enabled=['Profits'];
      enabled.forEach( e =>
      {                  
        if (this.user.d_charts[e])
        {
          if (this.user.d_charts[e].reduce((a, b) => a + b, 0)!=0) 
          {
            let lc={"Profits":[colors.mygreen.lighten2, colors.mygreen.lighten2],"Purchases":[colors.red.base, colors.red.accent3],"walmart":[colors.blue.base, colors.blue.accent3],"rakuten":[colors.orange.base, colors.orange.accent4],"total":[colors.red.base, colors.red.accent4]};
            this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
            this.empty_dataset.data = this.user.d_charts[e];
            this.empty_dataset.gradientStroke= lc[e];
            this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
            datasetscount++
          }
        }
      });
      return this.data;
    },
  },
  data() {
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading:false,
      timeframe_dialog: false,
      errorid: null,
      search: '',
      showingTasks: "View All",
      orders: null,
      enabled_eBayAccounts: [],
      totalrevenue: null,
      empty_dataset:
      {
        label: '',
        yAxisID:1,
        fill: false,
        data: null,
        shadowOffsetX: 3,
        shadowOffsetY: 3,
        shadowBlur: 10,
        shadowColor: "rgba(103, 116, 132, 0.5)",
        pointRadius: 4,
        pointBevelWidth: 3,
        pointHoverRadius: 6,
        pointHoverBevelWidth: 4.5,
        pointHoverInnerGlowWidth: 20,
        pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
        gradientStroke: [colors.mygreen.darken2, colors.mygreen.darken2],

      },
      data: 
      {
        labels: null,
        datasets: null
      },
      option: 
      {
        responsive: true,
        scaleOverride: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: "nearest",
          backgroundColor:'rgba(255,255,255,0.85)',
          titleFontColor:'#333',
          bodyFontColor: '#333',
          xPadding:15,
          yPadding:15,
          intersect: true,
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        legend: {
          display: true,
          position:'bottom',
          align: 'start',
          labels:{
            boxWidth: 5,
            usePointStyle: true
          },
          intersect: false,
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            bottom: 10,
            top: 10,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
              },
              zeroLineWidth: 1,
            }
          ],
          yAxes: [
            {
             id:1,
             position: 'left',
             display: true,
             zeroLineWidth: 1,
             scalePositionLeft: true,
             ticks: {
                beginAtZero: true
              },
              gridLines: {
                offsetGridLines: false,
                zeroLineColor: '#ff0000',
              }
            },
          ]
        }
      },
    };
  },
  created(){
		var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth();
    var d = date.getDate();
    var k = new Date(y,m,0).getDate();
    var firstDay = new Date(y, m, d-k+1);
    var lastDay = new Date(y, m , d+1);
    this.user.timeframe=[firstDay.toISOString().split('T')[0],lastDay.toISOString().split('T')[0]];
    //this.loadData()
  },
  methods:
  {
    changed_dateselector(){
      //console.log(this.user.timeframe);
      if (this.user.timeframe[0]>this.user.timeframe[1])
      {
        let tmp=this.user.timeframe[0];
        this.user.timeframe[0]=this.user.timeframe[1]
        this.user.timeframe[1]=tmp;
      }
      //this.loadData();
    },
    RefreshData(){
      if (this.enabled_eBayAccounts.length==this.user.eBayAccounts.split(',').length)
      {
        this.enabled_eBayAccounts=[];
      }
      //this.loadData();
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      let datasetscount=0;
      try{
          let lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
          const res = await this.$http.post('/reports/revenue_report.php', {"timeframe":this.timeframe.toString(),"sellers":this.enabled_eBayAccounts.toString()});
          switch (res.data.errorid)
          {
            case '0':
              //this.orders=res.data.payload.table;
              this.data.labels = res.data.payload.labels;
              this.totalrevenue=res.data.payload.totalrevenue;
              this.data.datasets=[];
              let datasetscount=0
              let enabled='Purchase,Sale';
              enabled.forEach( e =>
              {                  
                if (data[e])
                {
                  if (data[e].reduce((a, b) => a + b, 0)>0) 
                  {
                    this.empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
                    this.empty_dataset.data = data[e];
                    this.empty_dataset.gradientStroke= lc[datasetscount];
                    this.data.datasets.push(JSON.parse(JSON.stringify(this.empty_dataset)));
                    datasetscount++
                  }
                }
              });

            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
              //this.LineChart.update();
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
    },
    beforeDestroy() {
      this.chartProperties = null;
      delete this.chartProperties;
    },
  }
}
</script>